import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const CountryNameDisplay: React.FC<{ countryCode: string }> = (
    props
) => {
    const { t } = useTranslation('countries');

    return <Typography>{t('COUNTRIES.' + props.countryCode)}</Typography>;
};
